import { Redirect, Route, Switch } from "react-router-dom";

import {
  routeHelperPayrollRunsDashboard,
  routeHelperPayrollRunsDetails,
  routeHelperPayrollRunsPaystub
} from "./paths";
import { RoutePayrollRunsDashboard } from "./routes/RoutePayrollRunsDashboard";
import { RoutePayrollRunsDetails } from "./routes/RoutePayrollRunsDetails";
import { RoutePayrollRunsPaystub } from "./routes/RoutePayrollRunsPaystub";
import { getDefaultPayrollRunYear } from "./utils";

/**
 * The W-2 employee payroll surface, built to the new payroll design
 * (`TablePayrollsEmployee`, `PayrollRunDetailsEmployee`).
 *
 * The module also houses the contractor screens the Payables "Payroll Runs" tab
 * mounts (`TablePayrollsContractor`, `PayrollRunDetailsContractor`), because
 * both read the same `PayrollRun` resource. They are separate components, not
 * variants: the Payables surface keeps the retired v1 layout its payers know,
 * and only leaf pieces (the count cell, selectors) are shared.
 */
export const PayrollRunsIndex: React.FC = () => {
  return (
    <Switch>
      <Route
        component={RoutePayrollRunsPaystub}
        path={routeHelperPayrollRunsPaystub.path}
      />
      <Route
        component={RoutePayrollRunsDetails}
        path={routeHelperPayrollRunsDetails.path}
      />
      <Route
        component={RoutePayrollRunsDashboard}
        path={routeHelperPayrollRunsDashboard.path}
      />

      <Redirect
        from="*"
        to={routeHelperPayrollRunsDashboard.createLocationObject({
          year: getDefaultPayrollRunYear()
        })}
      />
    </Switch>
  );
};
